import { useEffect, useState } from "react";

const SCROLL_THRESHOLD = 15;

function getScrollTop() {
  const app = document.querySelector(".App");
  if (app && app.scrollHeight > app.clientHeight) {
    return app.scrollTop;
  }
  return window.scrollY;
}

export function useMobileHeaderScroll(enabled: boolean) {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setIsScrolled(false);
      return undefined;
    }

    const handleScroll = () => setIsScrolled(getScrollTop() > SCROLL_THRESHOLD);

    const appElement = document.querySelector(".App");

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    appElement?.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
      appElement?.removeEventListener("scroll", handleScroll);
    };
  }, [enabled]);

  return isScrolled;
}
